import { css } from "lit";

/**
 * Custom light theme — "Sky & Clouds"
 *
 * Sky blue page, white cards floating like clouds.
 * Black text on white for maximum contrast.
 * Red accent for selected/active elements.
 * Yellow for secondary actions (sunshine).
 * Very rounded corners for a soft, toylike feel.
 */
export const customLightThemeVars = css`
  /* Application Variables */
  --bab-bg: #44aaff;              /* Sky blue */
  --bab-card-bg: #ffffff;         /* Cloud white */
  --bab-text: #000000;            /* Black — 21:1 on white */
  --bab-text-secondary: #cc0000;  /* Red — warm against cool blue sky */
  --bab-border: #000000;          /* Black outline */
  --bab-accent: #ee0000;          /* Red — selected buttons, primary CTA */
  --bab-banner-bg: #d6eeff;       /* Soft sky blue tint */
  --bab-banner-text: #001f5e;     /* Dark navy text */
  --bab-banner-border: #4488cc;   /* Medium blue border */
  --bab-input-bg: #ffffff;
  --bab-input-text: #000000;
  --bab-button-secondary-bg: #ffdd00; /* Sunshine yellow */
  --bab-button-secondary-text: #000000; /* Black on yellow — 14.7:1 */

  /* Structural */
  --bab-border-width: 3px;
  --bab-radius: 18px;             /* Very rounded — bubbly, toylike */
  --bab-font-weight: 900;
`;

/**
 * Custom dark theme — "Midnight Navy"
 *
 * Deep navy background like a night sky.
 * White text, yellow secondary (stars).
 * Red for active/selected elements.
 * Green secondary button. Yellow banner — most visible against navy.
 */
export const customDarkThemeVars = css`
  /* Application Variables */
  --bab-bg: #0a1628;              /* Deep navy night sky */
  --bab-card-bg: #142038;         /* Slightly lighter navy for cards */
  --bab-text: #ffffff;            /* White */
  --bab-text-secondary: #ffe000;  /* Yellow — 18:1 on navy, like stars */
  --bab-border: #ffffff;          /* White outlines */
  --bab-accent: #ff3333;          /* Red — selected buttons, primary CTA */
  --bab-banner-bg: #1a3a6a;       /* Medium navy — distinct from page */
  --bab-banner-text: #ffe000;     /* Yellow text — 12:1 on medium navy */
  --bab-banner-border: #2a5a9a;   /* Slightly lighter navy border */
  --bab-input-bg: #0a1628;        /* Same as page bg */
  --bab-input-text: #ffffff;
  --bab-button-secondary-bg: #00bb44; /* Green secondary action */
  --bab-button-secondary-text: #ffffff;

  /* Structural */
  --bab-border-width: 3px;
  --bab-radius: 12px;
  --bab-font-weight: 900;
`;
